import { TCompanyConfigs } from '../../../../shared/services/companyConfig/companyConfig.service';
import {
  ReportsConfigurationRes,
  DataForReportsConfigurationPreviewRes,
  ListReportPrinterMappingsQueryRes,
} from '../services/printForms.service';
import {
  DictCompanyPrintersQueryRes,
  DictSubCompaniesRes,
  DictTranslationLanguagesQueryRes,
} from '../../../../shared/services/configsData/configsData.service.ts';

export enum PrintFormsTabs {
  general = 'general',
  reportConfiguration = 'report-configuration',
  printersAssignment = 'printers-assignment',
  email = 'email',
}

export interface ITabState {
  companyNameInReports: TCompanyConfigs['companyNameInReports'];
  inputDataForReportsPreview: DataForReportsConfigurationPreviewRes;
  reportConfiguration: ReportsConfigurationRes;
  companyPrinters: DictCompanyPrintersQueryRes;
  listReportPrinterMappings: ListReportPrinterMappingsQueryRes;
  subCompaniesOptions: DictSubCompaniesRes;
  isDefaultEmailTextForInvoice: TCompanyConfigs['isDefaultEmailTextForInvoice'];
  customEmailTextForInvoice: TCompanyConfigs['customEmailTextForInvoice'];
  isDefaultEmailTextForDebtor: TCompanyConfigs['isDefaultEmailTextForDebtor'];
  customEmailTextForDebtor: TCompanyConfigs['customEmailTextForDebtor'];
  isDefaultEmailTextForOrder: TCompanyConfigs['isDefaultEmailTextForOrder'];
  customEmailTextForOrder: TCompanyConfigs['customEmailTextForOrder'];
  isDefaultEmailTextForOffer: TCompanyConfigs['isDefaultEmailTextForOffer'];
  customEmailTextForOffer: TCompanyConfigs['customEmailTextForOffer'];
  orderEmailTextTranslations: TCompanyConfigs['orderEmailTextTranslations'];
  offerEmailTextTranslations: TCompanyConfigs['offerEmailTextTranslations'];
  invoiceEmailTextTranslations: TCompanyConfigs['invoiceEmailTextTranslations'];
  debtReminderEmailTextTranslations: TCompanyConfigs['debtReminderEmailTextTranslations'];
  translationLanguages: DictTranslationLanguagesQueryRes;
}
